/*global FB*/
import React, { useState, useEffect } from "react";
import { GoogleOAuthProvider } from '@react-oauth/google';
import { GoogleLogin } from '@react-oauth/google';
import axios from 'axios';
//import FacebookLogin from '@greatsumini/react-facebook-login';

export default function OAuthText() {	
	

	const [output, setOutput] = useState();
	
	useEffect(() => {
    // Load the Facebook SDK asynchronously
    window.fbAsyncInit = function() {
      FB.init({
        appId      : '573808334956264',
        cookie     : true,
        xfbml      : true,
        version    : 'v9.0'
      });
			
			FB.getLoginStatus(function(response) {
				console.log(response);
					//statusChangeCallback(response);
			});
			
    };
    (function(d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) { return; }
      js = d.createElement(s); js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
  }, []);
	
	
	
	const PrettyJSON = ({ data }) => {
		const json = JSON.stringify(data, null, 2); // Convert the JSON data to a string with 2 spaces of indentation
		const obj = JSON.parse(json); // Convert the JSON string back to an object
		
		const renderKeyValue = (key, value) => (
			<div key={key} style={{display:"flex"}}>
				<div style={{marginRight:"10px"}}><strong>{key}:</strong></div>
				<div>{value}</div>
			</div>
		);
		
		const renderObject = obj => (
			Object.keys(obj).map(key => {
				const value = obj[key];
				if (typeof value === "object") {
					return (
						<div key={key} style={{marginLeft:"20px",textAlign:"left"}}>
							<h4>{key}</h4>
							{renderObject(value)}
						</div>
					);
				} else {
					return renderKeyValue(key, value);
				}
			})
		);

		return (
			<div>
				{renderObject(obj)}
			</div>
		);
	}
	
	
	
	
	
	const GoogleLoginBtn = () => {
	 const handleSuccess = (response) => {
			console.log('Google OAuth success:', response);
		};

		const handleFailure = (response) => {
			console.log('Google OAuth failure:', response);
		};

		return (
			<div>
				<GoogleOAuthProvider clientId="1052264672877-ctj4bhhs69t6o6af11qocnf8acrr3aj9.apps.googleusercontent.com">
					<GoogleLogin
						onSuccess={handleSuccess}
						onFailure={handleFailure}
					/>
				</GoogleOAuthProvider>
			</div>
		);
	}
	
	function checkLoginState() {
    FB.getLoginStatus(function(response) {
      console.log(response);
    });
  }
	
	const handleLogin = () => {
    // Redirect the user to the Instagram authorization URL
    window.location.href = `https://api.instagram.com/oauth/authorize?client_id=573808334956264&redirect_uri=https://localhost:3000/oauthtest&scope=user_profile,user_media&response_type=code`;
  };
	
	const handleTokenExchange = async (code) => {
		console.log('hit');
		
		 try {
			const response = await axios.post(
				'https://api.instagram.com/oauth/access_token',
				{
					client_id: '573808334956264',
					client_secret: 'c78e875f23c03b3ed6552773a06d4c54',
					code: code,
					grant_type: 'authorization_code',
					redirect_uri: 'https://localhost:3000/oauthtest'
				}
			);

			const data = response.data;
			console.log(data);
			//setAccessToken(data.access_token);
		} catch (error) {
			console.error(error);
		}
  };
	
	useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");
    if (code) {
      handleTokenExchange(code);
    }
  }, []);
	
	
	
	const IGLoginBtn = () => {
		return (
      <div>
        <button onClick={handleLogin}>Log in with Instagram</button>
      </div>
    );
	}
	
	const FacebookLoginBtn = () => {
		const FBLoginButton = React.createFactory('fb:login-button');
		
		return (<div style={{
					backgroundColor: '#4267b2',
					color: '#fff',
					fontSize: '16px',
					padding: '12px 24px',
					border: 'none',
					borderRadius: '4px',
				}}>{
        React.createElement('fb:login-button', {
          scope: ['public_profile','email'],
          onlogin: checkLoginState
        })}
			</div>
		);
		/*return (
			<FacebookLogin
				appId="659772326207700"
				initParams={{
					version: 'v10.0',
				}}
				style={{
					backgroundColor: '#4267b2',
					color: '#fff',
					fontSize: '16px',
					padding: '12px 24px',
					border: 'none',
					borderRadius: '4px',
				}}
				
				onSuccess={(response) => {
					console.log('Login Success!', response);
				}}
				onFail={(error) => {
					console.log('Login Failed!', error);
				}}
				onProfileSuccess={(response) => {
					console.log('Get Profile Success!', response);
				}}
			/>
		);*/
	}
	
	return (
		<div id="test">
			<div style={{"width":"200px"}}>
				<GoogleLoginBtn />
			</div>
			<div>
				<FacebookLoginBtn />
			</div>
			<div>
				<IGLoginBtn />        
      </div>
			
			
		</div>
	);
}


